import React, { SVGProps } from 'react';

export const EjectIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13.513 3.696 5.996 6.977c1.12 1.303.2 3.327-1.512 3.327H6.004c-1.712 0-2.632-2.024-1.512-3.327l5.997-6.977a1.99 1.99 0 0 1 3.024 0Z"
      opacity=".4"
    />
    <path
      fill="currentColor"
      d="M4 18.2v1.6c0 .8.4 1.2 1.2 1.2h13.6c.8 0 1.2-.4 1.2-1.2v-1.6c0-.8-.4-1.2-1.2-1.2H5.2c-.8 0-1.2.4-1.2 1.2Z"
    />
  </svg>
);
